import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'navigation'
import { HumiLab, DialogueBox, Button, Input } from 'components/UIElements'
import { check, DCH } from '../../../../../assets/assets'
import '../stylesheets/changePassword.scss'

class ChangePasswordPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      eight: false,
      specialChars: false,
      lowercase: false,
      number: false,
      responsive: window.innerWidth < 768
    }
  }

  componentDidMount() {
    const {
      clearPasswordError,
      resetPasswordState,
      tempPassword,
      updateNewPassword
    } = this.props
    clearPasswordError()
    resetPasswordState()

    if (tempPassword) {
      updateNewPassword('oldPassword', tempPassword)
    }
    window.addEventListener('resize', this.setResponsive)
  }

  componentDidUpdate(prevProps) {
    const { tempPassword, updateNewPassword } = this.props
    if (!prevProps.tempPassword && tempPassword) {
      updateNewPassword('oldPassword', tempPassword)
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setResponsive)
  }

  setResponsive = () => {
    if (window.innerWidth < 768) {
      this.setState({ responsive: true })
    } else {
      this.setState({ responsive: false })
    }
  }

  validate = password => {
    const isEightCharacters = /^.{8,}$/g
    const hasSpecialChar = /^(.*[-~`!@#$%^&*()_+={[}\]|:;"'<,>.?/].*)$/g
    const hasLowercase = /^(.*[a-z].*)$/g
    const hasNumber = /^(.*\d.*)$/g

    if (password.match(isEightCharacters)) {
      this.setState({ eight: true })
    } else {
      this.setState({ eight: false })
    }
    if (password.match(hasSpecialChar)) {
      this.setState({ specialChars: true })
    } else {
      this.setState({ specialChars: false })
    }
    if (password.match(hasLowercase)) {
      this.setState({ lowercase: true })
    } else {
      this.setState({ lowercase: false })
    }
    if (password.match(hasNumber)) {
      this.setState({ number: true })
    } else {
      this.setState({ number: false })
    }
  }

  render() {
    const {
      isTempPassword,
      needsConsent,
      password,
      tempPassword,
      setNewPassword,
      strings,
      updateNewPassword
    } = this.props
    const { eight, lowercase, number, responsive, specialChars } = this.state
    const safePasswordState = password || {
      changePassword: {
        oldPassword: '',
        newPassword: '',
        newPasswordConfirmation: ''
      },
      passwordError: null
    }
    const { changePassword = {}, passwordError } = safePasswordState
    const {
      oldPassword = '',
      newPassword = '',
      newPasswordConfirmation = ''
    } = changePassword
    const shouldShowOldPassword = !isTempPassword || !tempPassword
    let redirectPath = isTempPassword ? '/my-activities' : '/profile'

    if (needsConsent) {
      redirectPath = '/consent'
    }
    return (
      <div className='change-password page'>
        <HumiLab />
        <DialogueBox>
          {responsive && (
            <div className='logo-title flexed center-justified'>
              <img src={DCH} className='logo' alt='linkt-logo' />
            </div>
          )}
          <h3>{strings.create_new_pw}</h3>
          {shouldShowOldPassword && (
            <Input
              hasError={
                passwordError !== strings.pw_mismatch && passwordError !== null
              }
              id='old-password'
              label={strings.type_old_password}
              autoFocus
              type='password'
              value={oldPassword}
              onChange={value => updateNewPassword('oldPassword', value)}
              pretext={
                passwordError !== strings.pw_not_matching
                  ? passwordError
                  : '' || ''
              }
            />
          )}
          <div className='validations'>
            <p>
              <span>{strings.pw_requirements_include}</span>
            </p>
            <p>
              {check(eight ? 'check' : '')}
              <span>{strings.pw_requirements_characters}</span>
            </p>
            <p>
              {check(specialChars ? 'check' : '')}
              <span>{strings.pw_requirements_special_char_linkt_web}</span>
            </p>
            <p>
              {check(lowercase ? 'check' : '')}
              <span>{strings.pw_requirements_lowercase}</span>
            </p>
            <p>
              {check(number ? 'check' : '')}
              <span>{strings.pw_requirements_number}</span>
            </p>
          </div>
          <Input
            id='user-password'
            label={strings.type_password_label}
            type='password'
            autoFocus={isTempPassword}
            value={newPassword}
            onChange={value => {
              this.validate(value)
              updateNewPassword('newPassword', value)
            }}
          />
          <Input
            id='user-password-confirmation'
            label={strings.retype_password}
            type='password'
            value={newPasswordConfirmation}
            onChange={value =>
              updateNewPassword('newPasswordConfirmation', value)
            }
            pretext={
              passwordError === strings.pw_not_matching
                ? passwordError
                : '' || ''
            }
          />
          <Button
            content={strings.set_password_btn}
            primary
            disabled={
              !eight ||
              !specialChars ||
              !lowercase ||
              !number ||
              !newPasswordConfirmation.length > 0 ||
              (shouldShowOldPassword && !oldPassword.length > 0)
            }
            onClick={() => {
              setNewPassword(safePasswordState, strings.pw_set, redirectPath)
            }}
          />
          <div className='cancel'>
            {!isTempPassword && (
              <Link to='/profile'>{strings.back_password}</Link>
            )}
          </div>
        </DialogueBox>
      </div>
    )
  }
}

export default ChangePasswordPage

ChangePasswordPage.propTypes = {
  clearPasswordError: PropTypes.func,
  isTempPassword: PropTypes.bool,
  needsConsent: PropTypes.bool,
  password: PropTypes.shape({
    changePassword: PropTypes.shape({
      newPassword: PropTypes.string,
      newPasswordConfirmation: PropTypes.string,
      oldPassword: PropTypes.string
    }),
    passwordError: PropTypes.string
  }),
  resetPasswordState: PropTypes.func,
  setNewPassword: PropTypes.func,
  strings: PropTypes.objectOf(PropTypes.string),
  tempPassword: PropTypes.string,
  updateNewPassword: PropTypes.func
}
